export function LoadingSkeleton({ className = '' }) {
  return (
    <div
      className={`animate-pulse rounded-lg bg-slate-200/80 dark:bg-slate-700/50 ${className}`}
      aria-hidden
    />
  );
}

export function CardSkeleton() {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <LoadingSkeleton className="mb-2 h-3 w-24" />
      <LoadingSkeleton className="h-8 w-36" />
    </div>
  );
}
